module.exports = __webpack_public_path__ + "087ea74b492074a17c41f2878fb30676.svg";